/**
 * Mikolito — Reactions Widget
 * Wgraj do Shopify: Assets → reactions-widget.js
 */

(function () {
  'use strict';

  // Konfiguracja — nadpisywana przez window.MikolitoReactions z pliku .liquid
  const CONFIG = window.MikolitoReactions || {};
  const REACTIONS_API_URL = CONFIG.apiUrl || 'https://aleksandrabrykowicz.pl/reactions/reactions.php';
  const ARTICLE_HANDLE    = CONFIG.articleHandle
    || document.querySelector('[data-article-handle]')?.dataset.articleHandle
    || window.location.pathname.split('/').pop()
    || 'unknown';

  const REACTIONS = [
    { key: 'funny',  emoji: '😄', label: 'Śmieszna'          },
    { key: 'lovely', emoji: '🥰', label: 'Cudowna'            },
    { key: 'more',   emoji: '🚀', label: 'Chcę więcej!'       },
    { key: 'worse',  emoji: '😔', label: 'Mogłaby być lepsza' },
  ];

  // ─── Stan ───
  let state = {
    counts:       { funny: 0, lovely: 0, more: 0, worse: 0 },
    userReaction: null,
    loading:      false,
    error:        false,
  };

  // ─── Init ───
  function init() {
    const containers = document.querySelectorAll('[data-reactions-widget]');
    if (!containers.length) return;
    containers.forEach(c => render(c));
    fetchCounts();
  }

  // ─── Render ───
  function render(container) {
    container.innerHTML = buildHTML();
    attachEvents(container);
  }

  function buildHTML() {
    const buttonsHTML = REACTIONS.map(r => {
      const count      = state.counts[r.key] || 0;
      const isActive   = state.userReaction === r.key;
      const countBadge = count > 0 ? `<span class="rxn-count">${count}</span>` : '';
      return `
        <button
          class="rxn-btn${isActive ? ' rxn-btn--active' : ''}"
          data-reaction="${r.key}"
          ${state.loading ? 'disabled' : ''}
          aria-pressed="${isActive}"
          aria-label="${r.label}${count > 0 ? `, ${count} głosów` : ''}"
        >
          <span class="rxn-emoji" aria-hidden="true">${r.emoji}</span>
          <span class="rxn-label">${r.label}</span>
          ${countBadge}
        </button>`;
    }).join('');

    const total     = Object.values(state.counts).reduce((a, b) => a + b, 0);
    const totalHTML = total > 0
      ? `<p class="rxn-total">${total} ${pluralReakcji(total)} – dziękujemy! 🧡</p>`
      : '';

    const errorHTML = state.error
      ? `<p class="rxn-error">Nie udało się połączyć z serwerem. Spróbuj odświeżyć stronę.</p>`
      : '';

    return `
      <div class="rxn-widget${state.loading ? ' rxn-widget--loading' : ''}">
        <div class="rxn-title">Jak Ci się podobała bajka?</div>
        <p class="rxn-subtitle">Zostaw reakcję – Twoja opinia dużo dla mnie znaczy 🧡</p>
        <div class="rxn-buttons" role="group" aria-label="Reakcje na bajkę">
          ${buttonsHTML}
        </div>
        ${totalHTML}
        ${errorHTML}
      </div>`;
  }

  function attachEvents(container) {
    container.querySelectorAll('.rxn-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        if (!state.loading) postReaction(btn.dataset.reaction);
      });
    });
  }

  // ─── API: GET ───
  async function fetchCounts() {
    try {
      const res  = await fetch(`${REACTIONS_API_URL}?article=${encodeURIComponent(ARTICLE_HANDLE)}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      state.counts       = data.counts       || state.counts;
      state.userReaction = data.userReaction || null;
      state.error        = false;
    } catch (err) {
      console.error('[Mikolito Reactions] fetchCounts:', err);
      state.error = true;
    } finally {
      document.querySelectorAll('[data-reactions-widget]').forEach(c => render(c));
    }
  }

  // ─── API: POST ───
  async function postReaction(reactionKey) {
    state.loading = true;
    const prev    = state.userReaction;

    // Optimistic update
    if (prev === reactionKey) {
      state.userReaction = null;
      state.counts[reactionKey] = Math.max(0, (state.counts[reactionKey] || 0) - 1);
    } else {
      if (prev) state.counts[prev] = Math.max(0, (state.counts[prev] || 0) - 1);
      state.userReaction = reactionKey;
      state.counts[reactionKey] = (state.counts[reactionKey] || 0) + 1;
    }
    document.querySelectorAll('[data-reactions-widget]').forEach(c => render(c));

    try {
      const res = await fetch(REACTIONS_API_URL, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ article: ARTICLE_HANDLE, reaction: reactionKey }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      if (data.counts) {
        state.counts       = data.counts;
        state.userReaction = data.userReaction ?? state.userReaction;
      }
      state.error = false;
    } catch (err) {
      console.error('[Mikolito Reactions] postReaction:', err);
      // Rollback
      state.userReaction = prev;
      if (prev === reactionKey) {
        state.counts[reactionKey] = (state.counts[reactionKey] || 0) + 1;
      } else {
        if (prev) state.counts[prev] = (state.counts[prev] || 0) + 1;
        state.counts[reactionKey] = Math.max(0, (state.counts[reactionKey] || 0) - 1);
      }
      state.error = true;
    } finally {
      state.loading = false;
      document.querySelectorAll('[data-reactions-widget]').forEach(c => render(c));
    }
  }

  // ─── Helper ───
  function pluralReakcji(n) {
    if (n === 1) return 'reakcja';
    if (n >= 2 && n <= 4) return 'reakcje';
    return 'reakcji';
  }

  // ─── Style ───
  function injectStyles() {
    if (document.getElementById('mikolito-rxn-styles')) return;
    const style = document.createElement('style');
    style.id = 'mikolito-rxn-styles';
    style.textContent = `
      .rxn-widget {
        background: #ffffff;
        border: 1.5px solid #E5DDD0;
        border-radius: 20px;
        padding: 22px 24px;
        margin-top: 32px;
        transition: opacity 0.2s;
      }
      .rxn-widget--loading { opacity: 0.7; pointer-events: none; }
      .rxn-title {
        font-family: 'Baloo 2', 'Nunito', sans-serif;
        font-size: 1rem; font-weight: 800; color: #1A1714; margin-bottom: 4px;
      }
      .rxn-subtitle {
        font-size: 0.82rem; color: #6B7280; font-weight: 600; margin-bottom: 16px;
      }
      .rxn-buttons { display: flex; gap: 10px; flex-wrap: wrap; }
      .rxn-btn {
        display: inline-flex; align-items: center; gap: 7px;
        background: #FDF8EE; border: 1.5px solid #E5DDD0; border-radius: 30px;
        padding: 9px 18px; font-family: 'Nunito', sans-serif;
        font-size: 0.88rem; font-weight: 700; color: #1A1714;
        cursor: pointer; transition: all 0.2s; user-select: none; white-space: nowrap;
      }
      .rxn-btn:hover:not(:disabled) {
        background: #FEF3C7; border-color: #F59E0B;
        transform: translateY(-2px); box-shadow: 0 4px 12px rgba(245,158,11,0.18);
      }
      .rxn-btn--active {
        background: #FEF3C7 !important; border-color: #F59E0B !important;
        color: #D97706 !important; box-shadow: 0 0 0 3px rgba(245,158,11,0.15);
      }
      .rxn-btn:disabled { cursor: not-allowed; opacity: 0.6; }
      .rxn-emoji { font-size: 1.1rem; line-height: 1; }
      .rxn-count {
        background: #F59E0B; color: #1F2937;
        font-size: 0.68rem; font-weight: 800;
        padding: 2px 7px; border-radius: 20px; min-width: 20px; text-align: center;
      }
      .rxn-btn--active .rxn-count { background: #D97706; color: #fff; }
      .rxn-total { font-size: 0.78rem; color: #6B7280; font-weight: 600; margin-top: 14px; }
      .rxn-error {
        font-size: 0.78rem; color: #DC2626; font-weight: 600;
        margin-top: 10px; padding: 8px 12px;
        background: #FEF2F2; border-radius: 8px;
      }
      @media (max-width: 480px) {
        .rxn-label { display: none; }
        .rxn-btn   { padding: 9px 14px; }
      }
    `;
    document.head.appendChild(style);
  }

  // ─── Start ───
  injectStyles();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
